import { useState, useEffect } from "react";

interface IProps {
	ref: HTMLDivElement | null;
	forceRerender?: number;
}

const useTrackHeight = ({ ref, forceRerender }: IProps): { height: number } => {
	const [height, setHeight] = useState(0);

	useEffect(() => {
		// create a mutation observer to track the height of the element
		if (ref) {
			// initialize on load:
			setHeight(ref.getBoundingClientRect()?.height || 0);

			// listen for changes:
			const observer = new MutationObserver(() => {
				setHeight(ref.getBoundingClientRect()?.height || 0);
			});
			observer.observe(ref, {
				attributes: true,
				characterData: true,
				childList: true,
				subtree: true,
			});

			return () => {
				observer.disconnect();
			};
		}
	}, [ref, forceRerender]);

	return {
		height
	};
};

export default useTrackHeight;
